import { render, staticRenderFns } from "./addAppNotif.vue?vue&type=template&id=013cd333&scoped=true"
import script from "./addAppNotif.vue?vue&type=script&lang=js"
export * from "./addAppNotif.vue?vue&type=script&lang=js"
import style0 from "./addAppNotif.vue?vue&type=style&index=0&id=013cd333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013cd333",
  null
  
)

export default component.exports